// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';

// // Import the real founder image asset from your project folder
// import founderPhoto from '../Assets/slider/1.jpg'; // Swap with your actual founder photo path

// const AboutFounder = () => {
//   const [btnHovered, setBtnHovered] = useState(false);

//   // Studio PaletteTokens
//   const theme = {
//     background: '#F8F6F2',    // Soft Alabaster White
//     surface: '#FFFFFF',       // Pure Container White
//     accent: '#D4AF37',        // Champagne Gold Accent
//     textMain: '#2C302E',      // Charcoal Slate
//     textMuted: '#7A827E',     // Soft Muted Sage Grey
//     border: 'rgba(44, 48, 46, 0.08)'
//   };

//   // Luxury Dynamic Entrance Animations
//   const inlineStyles = `
//     @keyframes profileReveal {
//       from { opacity: 0; transform: scale(1.03) translateY(20px); }
//       to { opacity: 1; transform: scale(1) translateY(0); }
//     }
//     @keyframes dataReveal {
//       from { opacity: 0; transform: translateY(30px); }
//       to { opacity: 1; transform: translateY(0); }
//     }
//     .animate-profile { animation: profileReveal 1.4s cubic-bezier(0.16, 1, 0.3, 1) forwards; }
//     .animate-data { animation: dataReveal 1.2s cubic-bezier(0.16, 1, 0.3, 1) forwards; }

//     /* ==================== SCREEN RESPONSIVE LAYOUT BREAKPOINTS ==================== */
//     @media (max-width: 991px) {
//       .founder-screen-wrapper { padding: 30px 20px !important; }
//       .founder-asymmetric-split { flex-direction: column !important; gap: 40px !important; }
//       .founder-visual-deck { min-width: 100% !important; height: 450px !important; flex: none !important; }
//       .founder-data-deck { min-width: 100% !important; flex: none !important; }
//       .founder-name-text { font-size: 2.6rem !important; }
//     }
//   `;

//   return (
//     <div className="founder-screen-wrapper" style={{
//       background: theme.background,
//       minHeight: '100vh',
//       color: theme.textMain,
//       padding: '40px 60px',
//       fontFamily: 'system-ui, -apple-system, sans-serif',
//       boxSizing: 'border-box',
//       overflowX: 'hidden'
//     }}>
//       <style>{inlineStyles}</style>

//       {/* Return Header */}
//       <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '40px' }}>
//         <Link to="/" style={{ color: theme.textMuted, textDecoration: 'none', fontSize: '0.9rem', letterSpacing: '1px', fontWeight: '500' }} onMouseEnter={(e) => e.target.style.color = theme.accent} onMouseLeave={(e) => e.target.style.color = theme.textMuted}>
//           ← Back to Studio
//         </Link>
//         <span style={{ fontSize: '0.75rem', color: theme.textMuted, letterSpacing: '3px', textTransform: 'uppercase', fontWeight: '600' }}>
//           Leadership Profile
//         </span>
//       </div>

//       {/* ==================== SPLIT ASYMMETRIC GRID PLATFORM ==================== */}
//       <div className="founder-asymmetric-split" style={{ display: 'flex', gap: '80px', alignItems: 'center', marginTop: '20px' }}>

//         {/* ==================== LEFT SIDE: FOUNDER PORTRAIT DECK ==================== */}
//         <div className="animate-profile founder-visual-deck" style={{
//           flex: '0.9',
//           minWidth: '340px',
//           height: '620px',
//           position: 'relative',
//           borderRadius: '24px',
//           overflow: 'hidden',
//           background: theme.surface,
//           boxShadow: '0 25px 55px rgba(44, 48, 46, 0.05)',
//           border: `1px solid ${theme.border}`
//         }}>
//           <img 
//             src={founderPhoto} 
//             alt="ST Interior Studio Founder Portrait" 
//             style={{ width: '100%', height: '100%', objectFit: 'cover' }}
//           />
//           {/* Subtle protection vignette gradient overlay film */}
//           <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'linear-gradient(to top, rgba(44, 48, 46, 0.2) 0%, transparent 100%)', pointerEvents: 'none' }} />
//         </div>

//         {/* ==================== RIGHT SIDE: EDITORIAL NARRATIVE DECK ==================== */}
//         <div className="animate-data founder-data-deck" style={{ flex: '1.2', minWidth: '360px' }}>
//           <span style={{ color: theme.accent, textTransform: 'uppercase', letterSpacing: '4px', fontSize: '0.85rem', fontWeight: '700', display: 'block', marginBottom: '10px' }}>
//             Creative Director & Founder
//           </span>

//           <h1 className="founder-name-text" style={{ fontSize: '3.5rem', fontWeight: '300', margin: '0 0 10px 0', letterSpacing: '0.5px', color: theme.textMain, lineHeight: '1.1' }}>
//             Shaping Visionary Spaces
//           </h1>

//           <span style={{ fontSize: '1.1rem', fontWeight: '500', color: theme.accent, display: 'block', marginBottom: '30px', fontFamily: 'serif', fontStyle: 'italic' }}>
//             "A space should not simply look beautiful; it must understand how you move."
//           </span>

//           <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', fontSize: '1.05rem', lineHeight: '1.8', color: theme.textMuted, maxWidth: '580px' }}>
//             <p style={{ margin: 0 }}>
//               With over a decade of hands-on architectural experience in Pune, our founder established ST Interior Studio on a single core principle: bridging rigid architectural drafting boundaries with warm, lived-in luxury design parameters.
//             </p>
//             <p style={{ margin: 0 }}>
//               Believing firmly in the power of fine pastel geometry and natural light optimization layouts, they oversee every single 3D rendering stage and material audit configuration personally. By establishing close technical relationships with top-tier hardware ecosystems like Häfele and Blum, they ensure your custom spaces execute perfectly from screen to site.
//             </p>
//             <p style={{ margin: 0 }}>
//               Under their guidance, our dedicated studio artisans continue to push micro-tolerance space-planning benchmarks, converting residential spaces across Pune into timeless spatial signatures.
//             </p>
//           </div>

//           {/* Core Signature Footnotes */}
//           <div style={{ marginTop: '40px', borderTop: `1px solid ${theme.border}`, paddingTop: '25px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '20px' }}>
//             <div>
//               <span style={{ fontSize: '0.75rem', textTransform: 'uppercase', color: theme.textMuted, letterSpacing: '1px', display: 'block' }}>Design Hub location</span>
//               <span style={{ fontSize: '1.1rem', fontWeight: '600', color: theme.textMain, marginTop: '2px', display: 'block' }}>Pune, MH, India</span>
//             </div>

//             <Link to="/ContactUs" style={{ textDecoration: 'none' }}>
//               <button 
//                 onMouseEnter={() => setBtnHovered(true)}
//                 onMouseLeave={() => setBtnHovered(false)}
//                 style={{
//                   background: btnHovered ? theme.accent : theme.textMain,
//                   color: '#FFFFFF',
//                   border: 'none',
//                   padding: '12px 30px',
//                   borderRadius: '30px',
//                   fontSize: '0.9rem',
//                   fontWeight: '600',
//                   letterSpacing: '1px',
//                   textTransform: 'uppercase',
//                   cursor: 'pointer',
//                   boxShadow: btnHovered ? '0 8px 20px rgba(212, 175, 55, 0.2)' : '0 4px 15px rgba(44, 48, 46, 0.15)',
//                   transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
//                 }}
//               >
//                 Consult the Founder
//               </button>
//             </Link>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// export default AboutFounder;

// import React, { useEffect, useState } from "react";
// import founderimg from '../Assets/FOUNDER.jpeg'
// const AboutFounder = () => {

//   const theme = {
//     background: '#F8F6F2',
//     surface: '#FFFFFF',
//     accent: '#D4AF37',
//     textMain: '#2C302E',
//     textMuted: '#7A827E',
//     border: 'rgba(44, 48, 46, 0.08)'
//   };

//   const inputStyle = (theme) => ({
//     width: "100%",
//     padding: "18px 20px",
//     borderRadius: "16px",
//     border: `1px solid ${theme.border}`,
//     outline: "none",
//     fontSize: "15px",
//     background: theme.background,
//     color: theme.textMain,
//     boxSizing: "border-box"
//   });

//   const [animate, setAnimate] = useState(false);
//   const [openForm, setOpenForm] = useState(false);

//   useEffect(() => {
//     setTimeout(() => {
//       setAnimate(true);
//     }, 200);
//   }, []);



//   return (
//     <div
//       style={{
//         // width: "100%",
//         minHeight: "100vh",
//         background: theme.background,
//         padding: '40px 60px',

//         boxSizing: "border-box",
//         overflow: "hidden",
//         fontFamily: 'system-ui, -apple-system, sans-serif',
//         position: "relative"
//       }}
//     >

//       {/* Background Blur Circles */}
//       <div
//         style={{
//           position: "absolute",
//           top: "-120px",
//           right: "-120px",
//           width: "320px",
//           height: "320px",
//           borderRadius: "50%",
//           background: "rgba(212,175,55,0.12)",
//           filter: "blur(20px)"
//         }}
//       />

//       <div
//         style={{
//           position: "absolute",
//           bottom: "-150px",
//           left: "-120px",
//           width: "350px",
//           height: "350px",
//           borderRadius: "50%",
//           background: "rgba(44,48,46,0.06)",
//           filter: "blur(20px)"
//         }}
//       />

//       {/* Main Container */}
//       <div
//         style={{
//           maxWidth: "1350px",
//           margin: "0 auto",
//           display: "flex",
//           flexWrap: "wrap",
//           alignItems: "center",
//           justifyContent: "space-between",
//           gap: "60px",
//           position: "relative",
//           zIndex: 2
//         }}
//       >

//         {/* LEFT CONTENT */}
//         <div
//           style={{
//             flex: "1 1 550px",
//             transform: animate ? "translateX(0px)" : "translateX(-100px)",
//             opacity: animate ? 1 : 0,
//             transition: "1.2s ease"
//           }}
//         >

//           {/* Small Badge */}
//           <div
//             style={{
//               display: "inline-flex",
//               alignItems: "center",
//               gap: "10px",
//               background: "rgba(212,175,55,0.12)",
//               padding: "10px 20px",
//               borderRadius: "50px",
//               marginBottom: "30px",
//               border: `1px solid ${theme.border}`
//             }}
//           >
//             <div
//               style={{
//                 width: "10px",
//                 height: "10px",
//                 borderRadius: "50%",
//                 background: theme.accent,
//                 animation: "pulse 2s infinite"
//               }}
//             />
//             <span
//               style={{
//                 color: theme.textMain,
//                 fontSize: "14px",
//                 fontWeight: 600,
//                 letterSpacing: "1px",

//               }}
//             >
//               FOUNDER STORY
//             </span>
//           </div>

//           {/* Main Heading */}


//           {/* ==================== SCREEN ACCURATE TYPOGRAPHY HEADLINE ==================== */}
//           <h1
//             className="founder-heading-text"
//             style={{
//               fontSize: "3.5rem",
//               lineHeight: "1.2",
//               color: theme.textMain,
//               margin: "10px 0 0 0",
//               fontWeight: "300",          // Matches the editorial light feel of your selected blueprints title
//               letterSpacing: "1px",        // Matches your Studio Journals heading tracking layout
//               textTransform: "uppercase"  // Unified capitalization framework
//             }}
//           >
//             Turning{" "}
//             <span
//               style={{
//                 color: theme.accent,
//                 display: "block",
//                 fontWeight: "600"         // Clean bold emphasis on the accent spatial word
//               }}
//             >
//               Spaces
//             </span>
//             Into Stories
//           </h1>

//           {/* Description */}
//           <p
//             style={{
//               marginTop: "35px",
//               color: theme.textMuted,
//               fontSize: "17px",
//               lineHeight: "34px",
//               maxWidth: "650px"
//             }}
//           >
//             Founded with a passion for timeless interiors and modern
//             luxury, ST Interior was built on the belief that every
//             space should feel personal, elegant, and unforgettable.
//             What started as a dream has now transformed into a studio
//             designing premium residential and commercial experiences.
//           </p>

//           {/* Journey Cards */}
//           <div
//             style={{
//               display: "flex",
//               flexWrap: "wrap",
//               gap: "20px",
//               marginTop: "45px"
//             }}
//           >

//             {[
//               {
//                 title: "2019",
//                 desc: "Started with a vision to redefine luxury interiors."
//               },
//               {
//                 title: "50+",
//                 desc: "Premium spaces transformed across India."
//               },
//               {
//                 title: "Creative",
//                 desc: "Minimal, modern and emotionally connected designs."
//               }
//             ].map((item, index) => (
//               <div
//                 key={index}
//                 style={{
//                   flex: "1 1 180px",
//                   background: theme.surface,
//                   padding: "28px",
//                   borderRadius: "24px",
//                   border: `1px solid ${theme.border}`,
//                   boxShadow: "0 15px 40px rgba(0,0,0,0.04)",
//                   transition: "0.4s",
//                   cursor: "pointer"
//                 }}
//                 onMouseEnter={(e) => {
//                   e.currentTarget.style.transform = "translateY(-10px)";
//                 }}
//                 onMouseLeave={(e) => {
//                   e.currentTarget.style.transform = "translateY(0px)";
//                 }}
//               >
//                 <h2
//                   style={{
//                     margin: 0,
//                     color: theme.accent,
//                     fontSize: "34px"
//                   }}
//                 >
//                   {item.title}
//                 </h2>

//                 <p
//                   style={{
//                     marginTop: "14px",
//                     color: theme.textMuted,
//                     lineHeight: "28px",
//                     fontSize: "15px"
//                   }}
//                 >
//                   {item.desc}
//                 </p>
//               </div>
//             ))}

//           </div>

//           {/* Button */}
//           {/* Button */}
//           <button
//             onClick={() => setOpenForm(true)}
//             style={{
//               marginTop: "45px",
//               background: theme.textMain,
//               color: "#fff",
//               border: "none",
//               padding: "18px 38px",
//               borderRadius: "60px",
//               fontSize: "15px",
//               fontWeight: 600,
//               letterSpacing: "1px",
//               cursor: "pointer",
//               transition: "0.4s",
//               boxShadow: "0 15px 30px rgba(44,48,46,0.2)"
//             }}
//             onMouseEnter={(e) => {
//               e.currentTarget.style.transform = "scale(1.05)";
//               e.currentTarget.style.background = theme.accent;
//             }}
//             onMouseLeave={(e) => {
//               e.currentTarget.style.transform = "scale(1)";
//               e.currentTarget.style.background = theme.textMain;
//             }}
//           >
//             JOIN TEAM
//           </button>

//         </div>

//         {/* RIGHT IMAGE SECTION */}
//         <div
//           style={{
//             flex: "1 1 450px",
//             position: "relative",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             transform: animate ? "translateX(0px)" : "translateX(100px)",
//             opacity: animate ? 1 : 0,
//             transition: "1.3s ease"
//           }}
//         >

//           {/* Gold Background */}
//           <div
//             style={{
//               position: "absolute",
//               width: window.innerWidth < 768 ? "300px" : "480px",
//               height: window.innerWidth < 768 ? "380px" : "620px",
//               background: "linear-gradient(180deg, rgba(212,175,55,0.18), rgba(212,175,55,0.02))",
//               borderRadius: "250px",
//               transform: "rotate(-8deg)"
//             }}
//           />

//           {/* Main Founder Image */}
//           <div
//             style={{
//               width: window.innerWidth < 768 ? "280px" : "430px",
//               height: window.innerWidth < 768 ? "380px" : "600px",
//               borderRadius: "40px",
//               overflow: "hidden",
//               position: "relative",
//               zIndex: 2,
//               boxShadow: "0 25px 60px rgba(0,0,0,0.15)",
//               animation: "float 5s ease-in-out infinite"
//             }}
//           >
//             <img
//               src={founderimg}
//               alt="Founder"
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "cover"
//               }}
//             />

//             {/* Overlay */}

//             <div
//               style={{
//                 position: "absolute",
//                 bottom: 0,
//                 left: 0,
//                 width: "100%",
//                 padding: "40px 30px 35px 30px",
//                 background:
//                   "linear-gradient(to top, rgba(0,0,0,0.92), rgba(0,0,0,0.15), transparent)",
//                 zIndex: 5
//               }}
//             >
//               <h2
//                 style={{
//                   color: "#fff",
//                   margin: 0,
//                   fontSize: window.innerWidth < 768 ? "24px" : "34px",
//                   fontWeight: "700",
//                   letterSpacing: "1px",
//                   textTransform: "uppercase",
//                   lineHeight: "1.2"
//                 }}
//               >
//                 Ar.Shreya Thakare
//               </h2>

//               <p
//                 style={{
//                   color: "rgba(255,255,255,0.88)",
//                   marginTop: "10px",
//                   fontSize: "15px",
//                   letterSpacing: "2px",
//                   textTransform: "uppercase"
//                 }}
//               >
//                 Founder & Creative Director
//               </p>
//             </div>

//           </div>

//           {/* Floating Quote Card */}
//           <div
//             className="responsive-founder-quote-card" // 1. INJECT CLASS HERE TO OVERRIDE ABSOLUTE POSITIONING ON MOBILE
//             style={{
//               position: "absolute",
//               bottom: "140px",
//               left: window.innerWidth < 768 ? "0px" : "-40px",
//               background: theme.surface,
//               padding: "24px",
//               width: "240px",
//               borderRadius: "24px",
//               boxShadow: "0 20px 40px rgba(0,0,0,0.08)",
//               zIndex: 3,
//               border: `1px solid ${theme.border}`,
//               animation: "float 4s ease-in-out infinite"
//             }}
//           >
//             <p
//               style={{
//                 margin: 0,
//                 color: theme.textMuted,
//                 lineHeight: "30px",
//                 fontSize: "15px",
//                 fontStyle: "italic"
//               }}
//             >
//               “Luxury is not about expensive interiors. It’s about
//               creating emotions inside a space.”
//             </p>
//           </div>


//           {/* ================= JOIN TEAM FORM ================= */}


//         </div>

//         {openForm && (
//           <div
//             style={{
//               position: "fixed",
//               inset: 0,
//               background: "rgba(0,0,0,0.6)",
//               backdropFilter: "blur(8px)",
//               zIndex: 99999,
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               padding: "20px"
//             }}
//           >
//             <div
//               style={{
//                 width: "80%",
//                 maxWidth: "700px",
//                 maxHeight: "60vh",
//                 overflowY: "auto",
//                 background: theme.surface,
//                 borderRadius: "30px",
//                 padding: "40px",
//                 position: "relative",
//                 animation: "popupOpen 0.4s ease",
//                 boxShadow: "0 30px 80px rgba(0,0,0,0.2)"
//               }}
//             >

//               {/* Close */}
//               <button
//                 onClick={() => setOpenForm(false)}
//                 style={{
//                   position: "absolute",
//                   top: "20px",
//                   right: "20px",
//                   width: "45px",
//                   height: "45px",
//                   borderRadius: "50%",
//                   border: "none",
//                   background: theme.background,
//                   cursor: "pointer",
//                   fontSize: "22px",
//                   color: theme.textMain
//                 }}
//               >
//                 ×
//               </button>

//               {/* Heading */}
//               <h2
//                 style={{
//                   margin: 0,
//                   fontSize: "42px",
//                   color: theme.textMain,
//                   fontWeight: "600"
//                 }}
//               >
//                 Join Our Team
//               </h2>

//               <p
//                 style={{
//                   marginTop: "15px",
//                   color: theme.textMuted,
//                   lineHeight: "30px"
//                 }}
//               >
//                 Become part of ST Interior and help us create timeless luxury spaces.
//               </p>

//               {/* Form */}
//               <form
//                 action="https://api.web3forms.com/submit"
//                 method="POST"
//                 encType="multipart/form-data"
//                 style={{
//                   marginTop: "35px",
//                   display: "flex",
//                   flexDirection: "column",
//                   gap: "20px"
//                 }}
//               >

//                 {/* WEB3FORMS ACCESS KEY */}
//                 <input
//                   type="hidden"
//                   name="access_key"
//                   value="48cdcf48-2a69-4c0c-ab4f-b7435920f07e"
//                 />

//                 <input
//                   type="text"
//                   name="name"
//                   placeholder="Full Name"
//                   required
//                   style={inputStyle(theme)}
//                 />

//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="Email Address"
//                   required
//                   style={inputStyle(theme)}
//                 />

//                 <input
//                   type="tel"
//                   name="phone"
//                   placeholder="Phone Number"
//                   style={inputStyle(theme)}
//                 />

//                 <input
//                   type="text"
//                   name="position"
//                   placeholder="Position Applying For"
//                   style={inputStyle(theme)}
//                 />

//                 <textarea
//                   name="message"
//                   placeholder="Tell us about yourself..."
//                   rows={5}
//                   style={{
//                     ...inputStyle(theme),
//                     resize: "none"
//                   }}
//                 />

//                 {/* Resume Upload */}
//                 <input
//                   type="file"
//                   name="attachment"
//                   accept=".pdf,.doc,.docx"
//                   // required
//                   style={inputStyle(theme)}
//                 />

//                 <button
//                   type="submit"
//                   style={{
//                     background: theme.textMain,
//                     color: "#fff",
//                     border: "none",
//                     padding: "18px",
//                     borderRadius: "16px",
//                     fontSize: "16px",
//                     fontWeight: "600",
//                     cursor: "pointer"
//                   }}
//                 >
//                   Submit Application
//                 </button>
//               </form>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* KEYFRAMES */}
//       <style>
//         {`
//                     @keyframes float {
//                         0% { transform: translateY(0px); }
//                         50% { transform: translateY(-15px); }
//                         100% { transform: translateY(0px); }
//                     }

//                     @keyframes pulse {
//                         0% {
//                             transform: scale(1);
//                             opacity: 1;
//                         }
//                         50% {
//                             transform: scale(1.5);
//                             opacity: 0.5;
//                         }
//                         100% {
//                             transform: scale(1);
//                             opacity: 1;
//                         }
//                     }
//                         .feedback-main-title { font-size: 2.2rem !important; }

//                         @keyframes popupOpen {
//     0% {
//         opacity: 0;
//         transform: scale(0.9) translateY(40px);
//     }
//     100% {
//         opacity: 1;
//         transform: scale(1) translateY(0px);
//     }
// }

// /* Add this class rule inside your existing 768px media query container */
// @media (max-width: 768px) {
//   .responsive-founder-quote-card {
//     position: relative !important;
//     top: 20px !important;       /* Adds padding below the main picture */
//     left: 0px !important;
//     bottom: auto !important;
//     width: 100% !important;     /* Expands cleanly to match card widths */
//     box-sizing: border-box !important;
//   }
// }

//                 `}

//       </style>
//     </div>
//   );
// };

// export default AboutFounder;


import React, { useEffect, useState, useRef } from "react";
import founderimg from '../Assets/FOUNDER.jpeg';

const AboutFounder = () => {
  const theme = {
    background: '#F8F6F2',
    surface: '#FFFFFF',
    accent: '#D4AF37',
    textMain: '#2C302E',
    textMuted: '#7A827E',
    border: 'rgba(44, 48, 46, 0.08)',
    glass: 'rgba(255, 255, 255, 0.7)'
  };

  const [isVisible, setIsVisible] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const sectionRef = useRef(null);

  // Intersection Observer for performance-friendly scroll animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const inputStyle = {
    width: "100%",
    padding: "12px 16px",
    borderRadius: "12px",
    border: `1px solid ${theme.border}`,
    outline: "none",
    fontSize: "14px",
    background: theme.background,
    color: theme.textMain,
    boxSizing: "border-box",
    transition: "border-color 0.3s, box-shadow 0.3s",
    fontFamily: "inherit"
  };
  const inlineStyles = {

    pillBtn: {
      padding: '14px 40px',
      fontSize: '1rem',
      fontWeight: '600',
      color: '#FFFFFF',
      backgroundColor: '#2C302E',
      border: 'none',
      borderRadius: '30px',
      cursor: 'pointer',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.25)',
      transition: 'all 0.2s ease',
      outline: 'none',
      textTransform: 'uppercase',
      letterSpacing: '1px',
      display: 'inline-block',
      fontFamily: "'Cinzel', Georgia, serif",
    }
  };


  return (
    <div
      ref={sectionRef}
      style={{
        minHeight: "100vh",
        background: theme.background,
        padding: '60px 24px',
        boxSizing: "border-box",
        overflow: "hidden",
        fontFamily: 'system-ui, -apple-system, sans-serif',
        position: "relative",
        display: "flex",
        alignItems: "center"
      }}
    >
      {/* Dynamic Background Mesh Patterns */}
      <div
        style={{
          position: "absolute",
          top: "-5%",
          right: "-10%",
          width: "50vw",
          height: "50vw",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(212,175,55,0.15) 0%, rgba(212,175,55,0) 70%)",
          filter: "blur(40px)",
          pointerEvents: "none"
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "-5%",
          left: "-10%",
          width: "45vw",
          height: "45vw",
          borderRadius: "50%",
          background: "radial-gradient(circle, rgba(44,48,46,0.08) 0%, rgba(44,48,46,0) 70%)",
          filter: "blur(40px)",
          pointerEvents: "none"
        }}
      />

      {/* Main Container */}
      <div
        className="founder-grid-container"
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          width: "100%",
          display: "grid",
          gridTemplateColumns: "1.1fr 0.9fr",
          alignItems: "center",
          gap: "60px",
          position: "relative",
          zIndex: 2
        }}
      >
        {/* LEFT CONTENT */}
        <div
          style={{
            transform: isVisible ? "translateY(0px)" : "translateY(50px)",
            opacity: isVisible ? 1 : 0,
            transition: "all 1s cubic-bezier(0.16, 1, 0.3, 1)",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start"
          }}
        >
          {/* Tagline Badge */}
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              background: "rgba(212,175,55,0.08)",
              padding: "8px 16px",
              borderRadius: "100px",
              marginBottom: "24px",
              border: `1px solid rgba(212,175,55,0.15)`
            }}
          >
            <span className="founder-pulse-dot" />
            <span
              style={{
                color: theme.textMain,
                fontSize: "12px",
                fontWeight: 700,
                letterSpacing: "1.5px",
                textTransform: "uppercase"
              }}
            >
              FOUNDER STORY
            </span>
          </div>

          {/* Headline */}
          <h1
            style={{
              fontSize: "clamp(2rem, 4vw, 2rem)",
              lineHeight: "1.15",
              color: theme.textMain,
              margin: "0 0 24px 0",
              fontWeight: "300",
              letterSpacing: "-0.5px",
              textTransform: "uppercase",
              fontFamily: "'Cinzel', Georgia, serif",

            }}
          >
            Design Expression By Shreya
            {/* <span
              style={{
                color: theme.accent,
                display: "inline-block",
                fontWeight: "700",
                position: "relative",
                fontFamily: "'Cinzel', Georgia, serif",

              }}
            >
              Spaces
            </span>{" "}
            Into Stories */}
          </h1>

          {/* Description Paragraph */}
          <p
            style={{

              color: '#6E7270',
              lineHeight: '1.8',
              fontSize: "clamp(15px, 1.2vw, 17px)",
              fontFamily: "'Cormorant Garamond', serif",


              fontWeight: '400',
              letterSpacing: '1px',
              margin: "0 0 35px 0",
              //  textTransform: "capitalize"
            }}
          >
            Ar. Shreya Thakare is the Founder and Principal Architect of STInterior Studio. She earned her Bachelor’s degree in Architecture from Smt. Kashibai Navale College of Architecture, Pune.During her training and after her graduation she worked with Architecture and Interior firms where she built a strong foundation in design, spatial planning, and architectural thinking.

          </p>
          <p
            style={{

              color: '#6E7270',
              lineHeight: '1.8',
              fontSize: "clamp(15px, 1.2vw, 17px)",
              fontFamily: "'Cormorant Garamond', serif",


              fontWeight: '400',
              letterSpacing: '1px',
              margin: "0 0 35px 0",
              //  textTransform: "capitalize"
            }}
          >
            Driven by an enduring passion for thoughtful design, she began her professional journey with a commitment to continuous learning and a meticulous attention to detail. Each experience shaped her design philosophy, refining her ability to create spaces that are both timeless and deeply personal.


          </p>

          <p
            style={{

              color: '#6E7270',
              lineHeight: '1.8',
              fontSize: "clamp(15px, 1.2vw, 17px)",
              fontFamily: "'Cormorant Garamond', serif",


              fontWeight: '400',
              letterSpacing: '1px',
              margin: "0 0 35px 0",
              //  textTransform: "capitalize"
            }}
          >
            <p
              style={{

                color: '#6E7270',
                lineHeight: '1.8',
                fontSize: "clamp(15px, 1.2vw, 17px)",
                fontFamily: "'Cormorant Garamond', serif",


                fontWeight: '400',
                letterSpacing: '1px',
                margin: "0 0 35px 0",
                //  textTransform: "capitalize"
              }}
            >
              Driven by an enduring passion for thoughtful design, she began her professional journey with a commitment to continuous learning and a meticulous attention to detail. Each experience shaped her design philosophy, refining her ability to create spaces that are both timeless and deeply personal.


            </p>


          </p>

          {/* Primary CTA Button */}
          {/* <button
            onClick={() => setOpenForm(true)}
            className="founder-cta-btn"
            style={{
              ...inlineStyles.pillBtn,
              backgroundColor: '#FFFFFF',
              color: '#2C302E',
              border: '1px solid rgba(44, 48, 46, 0.15)', // Subtle charcoal border
              padding: '12px 28px',
              borderRadius: '30px',
              fontSize: '0.9rem',
              fontWeight: '500',
              letterSpacing: '1.5px',
              textTransform: 'uppercase',
              cursor: 'pointer',
              transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
              outline: 'none'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.03)';
              e.currentTarget.style.backgroundColor = '#D4AF37'; // Your signature gold accent
              e.currentTarget.style.color = '#FFFFFF';
              e.currentTarget.style.borderColor = '#D4AF37';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.backgroundColor = '#FFFFFF'; // Returns back to clean white
              e.currentTarget.style.color = '#2C302E';
              e.currentTarget.style.borderColor = 'rgba(44, 48, 46, 0.15)';
            }}
          >
            JOIN OUR TEAM
          </button> */}

        </div>

        {/* RIGHT IMAGE SECTION */}
        <div
          style={{
            position: "relative",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            transform: isVisible ? "scale(1) translateX(0)" : "scale(0.95) translateX(30px)",
            opacity: isVisible ? 1 : 0,
            transition: "all 1.2s cubic-bezier(0.16, 1, 0.3, 1)"
          }}
        >
          {/* Stylized Architectural Frame behind image */}
          {/* Main Founder Image */}
          <div
            style={{
              width: window.innerWidth < 768 ? "280px" : "430px",
              height: window.innerWidth < 768 ? "380px" : "600px",
              borderRadius: "40px",
              overflow: "hidden",
              position: "relative",
              zIndex: 2,
              boxShadow: "0 25px 60px rgba(0,0,0,0.15)",
              animation: "float 5s ease-in-out infinite"
            }}
          >
            <img
              src={founderimg}
              alt="Founder"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover"
              }}
            />

            {/* Overlay */}

            <div
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                padding: "40px 30px 35px 30px",
                background:
                  "linear-gradient(to top, rgba(0,0,0,0.92), rgba(0,0,0,0.15), transparent)",
                zIndex: 5
              }}
            >
              <h2
                style={{
                  color: "#fff",
                  margin: 0,
                  fontSize: window.innerWidth < 768 ? "24px" : "34px",
                  fontWeight: "700",
                  letterSpacing: "1px",
                  textTransform: "uppercase",
                  lineHeight: "1.2"
                }}
              >
                Ar.Shreya Thakare
              </h2>

              <p
                style={{
                  color: "rgba(255,255,255,0.88)",
                  marginTop: "10px",
                  fontSize: "15px",
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                  // textAlign: "center",
                }}
              >
                PRINCIPAL ARCHITECT AND FOUNDER 
              </p>
            </div>

          </div>

          {/* Floating Quote Card */}
          {/* <div
            className="founder-floating-quote"
            style={{
              position: "absolute",
              bottom: "-30px",
              left: "-20px",
              background: theme.glass,
              backdropFilter: "blur(12px)",
              WebkitBackdropFilter: "blur(12px)",
              border: `1px solid ${theme.border}`,
              borderRadius: "16px",
              padding: "20px",
              maxWidth: "240px",
              zIndex: 5,
              boxShadow: "0 15px 35px rgba(0,0,0,0.06)",
              animation: "floatSlow 6s ease-in-out infinite"
            }}
          >
            <span style={{ fontSize: "28px", color: theme.accent, lineHeight: "0", display: "block", marginBottom: "8px" }}>“</span>
            <p
              style={{
                margin: 0,
                color: theme.textMain,
                fontSize: "13px",
                lineHeight: "1.6",
                fontStyle: "italic",
                fontWeight: "500"
              }}
            >
              Luxury is not about expensive materials. It is about crafting profound emotions inside a physical space.
            </p>
          </div> */}


        </div>



      </div>

      {/* ================= MODAL - NO-SCROLL SECURE FORM ================= */}
      {
        openForm && (
          <div
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(44, 48, 46, 0.4)",
              backdropFilter: "blur(12px)",
              WebkitBackdropFilter: "blur(12px)",
              zIndex: 99999,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "16px",
              boxSizing: "border-box"
            }}
          >
            {/* Modal Container */}
            <div
              className="modal-box"
              style={{
                width: "100%",
                maxWidth: "780px",
                maxHeight: "calc(100vh - 32px)", // Dynamic viewport enforcement
                background: theme.surface,
                borderRadius: "24px",
                boxShadow: "0 25px 60px rgba(0,0,0,0.15)",
                position: "relative",
                display: "flex",
                flexDirection: "column",
                animation: "modalFadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1)",
                overflow: "hidden"
              }}
            >
              {/* Close Button */}
              <button
                onClick={() => setOpenForm(false)}
                aria-label="Close modal"
                className="modal-close-btn"
                style={{
                  position: "absolute",
                  top: "16px",
                  right: "16px",
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  border: `1px solid ${theme.border}`,
                  background: theme.background,
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "20px",
                  color: theme.textMain,
                  zIndex: 10,
                  transition: "all 0.2s"
                }}
              >
                &times;
              </button>

              {/* Scrollable interior containing form */}
              <div
                style={{
                  padding: "36px",
                  overflowY: "auto",
                  flex: "1 1 auto",
                  display: "flex",
                  flexDirection: "column",
                  gap: "24px"
                }}
              >
                {/* Header inside Form */}
                <div>
                  <h2
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "28px",
                      color: theme.textMain,
                      fontWeight: "600",
                      letterSpacing: "-0.5px"
                    }}
                  >
                    Join Our Team
                  </h2>
                  <p
                    style={{
                      margin: 0,
                      color: theme.textMuted,
                      fontSize: "14px",
                      lineHeight: "1.5"
                    }}
                  >
                    Become part of ST Interior and help us shape the future of luxury environments.
                  </p>
                </div>

                {/* Form Element - Two-Column Layout */}
                <form
                  action="https://api.web3forms.com/submit"
                  method="POST"
                  encType="multipart/form-data"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px"
                  }}
                >
                  <input
                    type="hidden"
                    name="access_key"
                    value="48cdcf48-2a69-4c0c-ab4f-b7435920f07e"
                  />

                  {/* Input Fields Grid */}
                  <div
                    className="modal-form-grid"
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "16px"
                    }}
                  >
                    <input
                      type="text"
                      name="name"
                      placeholder="Full Name"
                      required
                      style={inputStyle}
                    />

                    <input
                      type="email"
                      name="email"
                      placeholder="Email Address"
                      required
                      style={inputStyle}
                    />

                    <input
                      type="tel"
                      name="phone"
                      placeholder="Phone Number"
                      style={inputStyle}
                    />

                    <input
                      type="text"
                      name="position"
                      placeholder="Position Applying For"
                      style={inputStyle}
                    />
                  </div>

                  <textarea
                    name="message"
                    placeholder="Tell us briefly about yourself..."
                    rows={3}
                    style={{
                      ...inputStyle,
                      resize: "none"
                    }}
                  />

                  {/* Resume Upload Box */}
                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <label style={{ fontSize: "12px", fontWeight: "600", color: theme.textMain, textTransform: "uppercase" }}>
                      Upload CV (PDF, DOC)
                    </label>
                    <input
                      type="file"
                      name="attachment"
                      accept=".pdf,.doc,.docx"
                      style={{
                        ...inputStyle,
                        padding: "8px 12px"
                      }}
                    />
                  </div>

                  <button
                    type="submit"
                    className="modal-submit-btn"
                    style={{
                      ...inlineStyles.pillBtn,
                      backgroundColor: '#FFFFFF',
                      color: '#2C302E',
                      border: '1px solid rgba(44, 48, 46, 0.15)', // Subtle charcoal border
                      padding: '12px 28px',
                      borderRadius: '30px',
                      fontSize: '0.9rem',
                      fontWeight: '500',
                      letterSpacing: '1.5px',
                      textTransform: 'uppercase',
                      cursor: 'pointer',
                      transition: 'all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
                      outline: 'none'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'scale(1.03)';
                      e.currentTarget.style.backgroundColor = '#D4AF37'; // Your signature gold accent
                      e.currentTarget.style.color = '#FFFFFF';
                      e.currentTarget.style.borderColor = '#D4AF37';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'scale(1)';
                      e.currentTarget.style.backgroundColor = '#FFFFFF'; // Returns back to clean white
                      e.currentTarget.style.color = '#2C302E';
                      e.currentTarget.style.borderColor = 'rgba(44, 48, 46, 0.15)';
                    }}
                  >
                    Submit Application
                  </button>
                </form>
              </div>

            </div>
          </div>
        )
      }

      {/* Global CSS Injectors for dynamic states and CSS-only interactions */}
      <style>
        {`
          /* Custom variables / interactions */
          .founder-pulse-dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: ${theme.accent};
            animation: dotPulse 2s infinite ease-in-out;
          }

          .founder-cta-btn:hover {
            background-color: ${theme.accent} !important;
            transform: translateY(-3px) scale(1.02);
            box-shadow: 0 12px 28px rgba(212,175,55,0.25) !important;
          }

          .founder-image-wrapper:hover img {
            transform: scale(1.04);
          }

          .modal-close-btn:hover {
            background-color: ${theme.textMain} !important;
            color: #fff !important;
            transform: rotate(90deg);
          }

          .modal-submit-btn:hover {
            background-color: ${theme.accent} !important;
            transform: translateY(-2px);
          }

          /* Hardware-accelerated Keyframe Animations */
          @keyframes dotPulse {
            0%, 100% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.6); opacity: 0.4; }
          }

          @keyframes floatSlow {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-8px); }
          }

          @keyframes modalFadeIn {
            from { opacity: 0; transform: scale(0.96) translateY(10px); }
            to { opacity: 1; transform: scale(1) translateY(0); }
          }

          /* Media Query Engine */
          @media (max-width: 991px) {
            .founder-grid-container {
              grid-template-columns: 1fr !important;
              gap: 50px !important;
            }
          }

          @media (max-width: 768px) {
            .modal-form-grid {
              grid-template-columns: 1fr !important;
              gap: 12px !important;
            }
            .founder-floating-quote {
              position: relative !important;
              left: 0 !important;
              bottom: 0 !important;
              margin-top: 24px !important;
              max-width: 100% !important;
            }
          }
        `}
      </style>

    </div >
  );
};

export default AboutFounder;